export function RunAfter(date, f) {
	let d = new Date(date);

}

window.RunAfter = function(date, f) {
	let d = new Date(date);
	let now = new Date(); 
	let delta = d.getTime() - now.getTime();
	if (delta<=0) {
		setTimeout(f, 2500);
	} else {
		setTimeout(f, delta);
	}
}